import { headerDock } from "./modules/header-docking";
import { contactForm } from "./modules/contact-form-popup";
import { equipeItems } from "./modules/equipe-items";
import { currentMenuItem } from "./modules/nav-walker";


document.addEventListener( 'DOMContentLoaded', function() {
    headerDock();
    contactForm();
    equipeItems();
    currentMenuItem();
  }
);
